/* ==========================================================================
   Widget "Tragen Sie es mit" (wear-it-with)
   - direkter AJAX-Add-to-Cart bei Einzelvarianten-Produkten
   - aufklappbare Groessen-/Variantenauswahl bei einem Optionsset
   - theme-eigener Quick-Cart-Drawer bei mehreren Optionen
   ========================================================================== */

(() => {
  if (customElements.get('wear-it-with')) return;

  const ADDED_LABEL = 'Hinzugefügt';
  const ADDED_TIMEOUT = 2000;
  const RECOMMENDATION_CLASS = 'quick-cart-drawer__trigger--recommendations';

  class WearItWith extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const quick = event.target.closest('[data-wiw-quick]');
      if (quick && this.contains(quick)) {
        event.preventDefault();
        this.openQuickCart(quick);
        return;
      }

      const toggle = event.target.closest('[data-wiw-toggle]');
      if (toggle && this.contains(toggle)) {
        event.preventDefault();
        this.toggleOptions(toggle);
        return;
      }

      const addButton = event.target.closest('[data-wiw-add]');
      if (addButton && this.contains(addButton)) {
        event.preventDefault();
        this.addToCart(addButton);
      }
    }

    /* ---------- Quick-Cart-Drawer des Themes oeffnen ---------- */

    openQuickCart(button) {
      const drawer = document.querySelector('quick-cart-drawer');
      const url = button.dataset.productUrl;

      if (!drawer || typeof drawer.fetchProductForQuickCartDrawer !== 'function') {
        if (url) window.location.href = url;
        return;
      }

      // Der Drawer erwartet entweder einen Trigger innerhalb einer
      // <product-card> oder die Recommendations-Klasse. Wir reichen ein
      // minimales Proxy-Target durch, damit das Widget-Markup unabhaengig
      // von der Card-Struktur bleibt.
      drawer.fetchProductForQuickCartDrawer({
        target: {
          classList: {
            contains: (name) => name === RECOMMENDATION_CLASS
          },
          closest: (selector) => button.closest(selector)
        }
      });
    }

    /* ---------- Groessenauswahl ---------- */

    toggleOptions(button) {
      const item = button.closest('.wear-it-with__item');
      const options = item && item.querySelector('.wear-it-with__options');
      if (!options) return;

      const willOpen = options.hidden;

      this.querySelectorAll('.wear-it-with__options').forEach((panel) => {
        panel.hidden = true;
      });
      this.querySelectorAll('[data-wiw-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });

      options.hidden = !willOpen;
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        const firstSwatch = options.querySelector('.wear-it-with__swatch:not([disabled])');
        if (firstSwatch) firstSwatch.focus();
      }
    }

    /* ---------- Warenkorb ---------- */

    get cart() {
      return (
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer')
      );
    }

    setMessage(item, text) {
      const message = item && item.querySelector('.wear-it-with__message');
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.classList.contains('is-loading')) return;

      const item = button.closest('.wear-it-with__item');
      const mainButton = item ? item.querySelector('.wear-it-with__button') : button;

      this.setMessage(item, '');
      button.classList.add('is-loading');
      if (mainButton !== button) mainButton.classList.add('is-loading');
      button.setAttribute('disabled', '');

      const cart = this.cart;
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      const addUrl =
        (window.routes && window.routes.cart_add_url) || '/cart/add';

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const data = await response.json();

        if (data.status || data.errors) {
          const errorText =
            data.description ||
            data.message ||
            (window.cartStrings && window.cartStrings.error) ||
            'Der Artikel konnte nicht hinzugefügt werden.';
          this.setMessage(item, errorText);
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }

        if (typeof window.updateCartCounters === 'function') {
          window.updateCartCounters();
        }
        if (typeof window.updateFreeShipping === 'function') {
          window.updateFreeShipping();
        }

        this.showAdded(item, mainButton);
      } catch (error) {
        console.error('[wear-it-with]', error);
        this.setMessage(
          item,
          (window.cartStrings && window.cartStrings.error) ||
            'Der Artikel konnte nicht hinzugefügt werden.'
        );
      } finally {
        button.classList.remove('is-loading');
        if (mainButton !== button) mainButton.classList.remove('is-loading');
        button.removeAttribute('disabled');
      }
    }

    showAdded(item, mainButton) {
      const options = item && item.querySelector('.wear-it-with__options');
      if (options) options.hidden = true;

      const toggle = item && item.querySelector('[data-wiw-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');

      if (!mainButton) return;

      const label = mainButton.querySelector('.wear-it-with__button-label');
      if (!label || mainButton.dataset.originalLabel) return;

      mainButton.dataset.originalLabel = label.textContent;
      label.textContent = ADDED_LABEL;
      mainButton.classList.add('is-added');

      setTimeout(() => {
        label.textContent = mainButton.dataset.originalLabel;
        delete mainButton.dataset.originalLabel;
        mainButton.classList.remove('is-added');
      }, ADDED_TIMEOUT);
    }
  }

  customElements.define('wear-it-with', WearItWith);
})();